export default __webpack_public_path__ + "static/Multi-lingualAudio_Default-211a84674307a879166a6007fd304c8a.png";